import axios from "axios";
import { Config } from "../../data/config";

export const SET_OPEN_AVIALABILITY_MODAL = "APP | SET_OPEN_AVIALABILITY_MODAL";
export const FOCUS_UNIT = "APP | FOCUS_UNIT";
export const SET_GEO_CITY = "APP | SET_GEO_CITY";
export const SET_EMERGENCY_MESSAGE = "APP | SET_EMERGENCY_MESSAGE";
export const SET_PAGE_REQUEST_FIBRESTREAM =
  "APP | SET_PAGE_REQUEST_FIBRESTREAM";
export const SET_PREVIOUS_PATHNAME = "APP | SET_PREVIOUS_PATHNAME";

export const setAvailabilityModal = flag => {
  return { type: SET_OPEN_AVIALABILITY_MODAL, payload: flag };
};

export function focusUnit() {
  return { type: FOCUS_UNIT };
}

export function setGeoCity(city) {
  return { type: SET_GEO_CITY, payload: city };
}

export function setEmergencyMessage(message) {
  return { type: SET_EMERGENCY_MESSAGE, payload: message };
}

export function getEmergencyStatus() {
  return function(dispatch) {
    axios
      .get(`${Config.frontApiUrl}/emergency`)
      .then(response => {
        dispatch(setEmergencyMessage(response.data.message));
      })
      .catch(error => {
        dispatch(setEmergencyMessage(null));
      });
  };
}

export function setPageRequestFibrestream(isPageRequestFibreStream) {
  return {
    type: SET_PAGE_REQUEST_FIBRESTREAM,
    payload: isPageRequestFibreStream
  };
}

export function setPreviousPathname(payload) {
  return { type: SET_PREVIOUS_PATHNAME, payload };
}



// WEBPACK FOOTER //
// ./src/store/actions/app.js